import i18n from '@/i18n/i18n'

export default [
  {
    path: '/rps/documents',
    name: 'rps-documents',
    component: () =>
      import('@/views/app/rps/documents/views/DocumentsView.vue'),
    meta: {
      authRequired: true,
      rule: 'editor',
      can: ['IU Repse'],
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: i18n.messages[i18n.locale].repse, url: '/rps/vendors' , active: true},
      ],
    },
  },
  {
    path: '/rps/vendors',
    name: 'rps-vendors',
    component: () => import('@/views/app/rps/vendors/views/VendorsView.vue'),
    meta: {
      authRequired: true,
      rule: 'editor',
      can: ['IU Repse'],
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: i18n.messages[i18n.locale].repse, url: '/rps/vendors' , active: true},
      ],
    },
  },
  {
    path: '/rps/vendor/:vendor/documents',
    name: 'rps-vendor-documents',
    component: () =>
      import('@/views/app/rps/vendor-documents/views/VendorDocumentsView.vue'),
    meta: {
      authRequired: true,
      rule: 'editor',
      can: ['IU Repse'],
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: i18n.messages[i18n.locale].repse, url: '/rps/vendors' , active: true},
      ],
    },
  },
  {
    path: '/rps/document/:document/requests',
    name: 'rps-document-requests',
    component: () =>
      import(
        '@/views/app/rps/document-requests/views/DocumentRequestsView.vue'
      ),
    meta: {
      authRequired: true,
      rule: 'editor',
      can: ['IU Repse'],
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: i18n.messages[i18n.locale].repse, url: '/rps/vendors' , active: true},
      ],
    },
  },
  {
    path: '/rps/logs',
    name: 'rps-logs',
    component: () => import('@/views/app/rps/logs/views/LogsView.vue'),
    meta: {
      authRequired: true,
      rule: 'editor',
      can: ['IU Repse'],
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: i18n.messages[i18n.locale].repse, url: '/rps/vendors' , active: true},
      ],
    },
  },
    {
    path: '/rps/notifications',
    name: 'rps-notifications',
    component: () => import('@/views/app/rps/notifications/views/NotificationsView.vue'),
    meta: {
      authRequired: true,
      rule: 'editor',
      can: ['IU Repse'],
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: i18n.messages[i18n.locale].repse, url: '/rps/vendors' , active: true},
      ],
    },
  },
  {
    path: '/rps/dashboard',
    name: 'rps-dashboard',
    component: () => import('@/views/app/rps/dashboard/views/DashboardView.vue'),
    meta: {
      authRequired: true,
      rule: 'editor',
      can: ['IU Repse'],
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: i18n.messages[i18n.locale].repse, url: '/rps/vendors' , active: true},
      ],
    },
  },
]
